import { useQuery } from '@tanstack/react-query';

const INSURANCE_SERVICE_URL =
  process.env.NEXT_PUBLIC_INSURANCE_SERVICE_URL || 'http://localhost:8004';
const REPORTS_URL = `${INSURANCE_SERVICE_URL}/api/v1/reports`;

export interface RenewalPipelineRow {
  policy_id: string;
  tenant_id: string;
  policy_number: string;
  insurer_id: string;
  policy_end_date: string;
  days_to_renewal: number;
}

function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return (
    window.localStorage.getItem('super_admin_token') ||
    window.localStorage.getItem('access_token')
  );
}

export const renewalPipelineReportKeys = {
  all: ['renewal-pipeline-report'] as const,
  asOf: (asOfDate: string) => [...renewalPipelineReportKeys.all, asOfDate] as const,
};

async function fetchRenewalPipelineReport(asOfDate: string): Promise<RenewalPipelineRow[]> {
  const params = new URLSearchParams({ as_of_date: asOfDate });
  const response = await fetch(`${REPORTS_URL}/renewal-pipeline?${params.toString()}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) {
    throw new Error(`Failed to load renewal pipeline report (${response.status})`);
  }
  return response.json();
}

/** Upcoming policy renewals, bucketed client-side by days_to_renewal, for the Renewal Pipeline report. */
export function useRenewalPipelineReport(asOfDate: string) {
  return useQuery({
    queryKey: renewalPipelineReportKeys.asOf(asOfDate),
    queryFn: () => fetchRenewalPipelineReport(asOfDate),
    staleTime: 30_000,
  });
}
